export default __webpack_public_path__ + "static/media/MiloRegular.0b883293.otf";